<template>

    <v-card class="elevation-12" id="login">
        <v-toolbar dark color="info">
            <v-toolbar-title>{{trans('auth-pages.reset.title')}}</v-toolbar-title>
        </v-toolbar>
        <template v-if="!sent">
            <v-card-text>

                <v-alert
                        v-if="error"
                        type="error"
                >{{error}}
                </v-alert>
                <v-form ref="form"
                        @submit.prevent
                        v-model="validForm"
                    >
                    <p class="lead">{{trans('auth-pages.reset.lead')}}</p>
                    <v-text-field
                            prepend-icon="email" name="email"
                            type="email"
                            :label="trans('auth-pages.reset.labels.email')"
                            :rules="emailRules"
                            :required="true"

                            :error-messages="fieldErrors.email"
                            @input="resetError('email')"
                            v-model="emailValue"
                        ></v-text-field>

                    <v-text-field
                            prepend-icon="lock"
                            name="password"
                            :label="trans('auth-pages.reset.labels.password')"
                            type="password"
                            v-model="password"
                            required

                            :rules="passwordRules"

                            :error-messages="fieldErrors.password"
                            @input="resetError('password')"
                    ></v-text-field>

                    <v-text-field
                            prepend-icon="lock"
                            ref="confirm"
                            name="password"
                            :label="trans('auth-pages.reset.labels.password_confirmation')"
                            type="password"
                            v-model="passwordConfirm"
                            required
                            :rules="passwordConfirmRules"

                            ></v-text-field>




                </v-form>
            </v-card-text>
            <v-card-actions>

            <v-spacer></v-spacer>
            <v-btn
                    :disabled="!validForm"
                    color="primary"
                    @click="submit"
            ><v-icon left>send</v-icon>{{trans('auth-pages.reset.submit')}}</v-btn>

            <v-spacer></v-spacer>
        </v-card-actions>
        </template>
        <template v-else>
            <v-card-text>
                <v-row align="center" justify="center" >
                    <v-icon d-flex size="80pt" mx-auto>vpn_key</v-icon>
                </v-row>
                <div class="text-h5 text-center">{{trans('auth-pages.reset.on-success')}}</div>
                <p class="text-center">{{trans('auth-pages.reset.on-success-descr')}}</p>
                <!--Successfull email password recovery-->
            </v-card-text>
        </template>
    </v-card>
</template>
<script>
    export default {
        name: "password-reset",
        props: {
            email:{type:String,required:false},
            token:{type:String,required:true},

            minPasswordLength:{type:Number,required:false,default:3},

            action:{type:String,default:'/password/reset'},
        },
        data() {
            return {
                emailValue:this.email,
                password:'',
                passwordConfirm:'',

                emailRules:[v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)||'invalid email'],
                passwordRules:[v => v.length>=this.minPasswordLength||'  '],
                passwordConfirmRules:[v => v===this.password||'Password does not match'],


                validForm:false,

                sent:false,

                error:null,
                fieldErrors:{},
            }
        },
        mounted() {
        },
        computed: {},
        methods: {
            back(){
                this.$emit('back')
            },
            submit(){

                let data ={
                    email:this.emailValue,
                    token:this.token,
                    password:this.password,
                    password_confirmation:this.passwordConfirm,

                };

                axios.post(this.action,data)
                    .then(r=>{
                        this.$emit('sent');
                        this.sent=true;
                    })
                    .catch(e=>{
                        if(e.response){
                            if(e.response.data){
                                console.log({e});
                                if(e.response.status===422){
                                    this.fieldErrors = e.response.data.errors;
                                }

                                this.error = e.response.data.message;
                            }
                            else{
                                this.error=e.response;
                            }
                        }else{
                            this.error=e;
                        }
                    })
            },
            resetError(field){
                this.fieldErrors[field]=[];
                this.error=null
            },
        },

        components: {},
        filters: {}
    }
</script>
